var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 16V8C19.5 7.72386 19.2761 7.5 19 7.5H12.7016C11.9068 7.5 11.1357 7.22952 10.5151 6.73304L9.11079 5.60957C9.02213 5.53864 8.91197 5.5 8.79844 5.5H5C4.72386 5.5 4.5 5.72386 4.5 6V16C4.5 16.2761 4.72386 16.5 5 16.5H19C19.2761 16.5 19.5 16.2761 19.5 16ZM5 4C3.89543 4 3 4.89543 3 6V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H12.7016C12.2474 6 11.8068 5.84544 11.4522 5.56174L10.0478 4.43826C9.6932 4.15456 9.25258 4 8.79844 4H5Z",
    fill: "#6247E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 15L11.25 9H12.75L12.75 15H11.25Z",
    fill: "#6247E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5303 12.5303L13.2374 14.8232C12.554 15.5066 11.446 15.5066 10.7626 14.8232L8.46967 12.5303L9.53033 11.4697L11.8232 13.7626C11.9209 13.8602 12.0791 13.8602 12.1768 13.7626L14.4697 11.4697L15.5303 12.5303Z",
    fill: "#6247E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveFolder);
export default __webpack_public_path__ + "static/media/archive_folder.93dd536b.svg";
export { ForwardRef as ReactComponent };